import {
  Code2,
  Smartphone,
  Users2,
  FileText,
  Plug,
  BrainCircuit,
} from "lucide-react";

export const SERVICES = [
  {
    icon: Code2,
    title: "Web Development",
    description:
      "Custom business websites, landing pages, redesigns, service pages, portfolios, and lead-generation websites.",
  },
  {
    icon: Smartphone,
    title: "Web & Mobile Apps",
    description:
      "Custom web apps and mobile-friendly applications for businesses that need tools beyond a basic website.",
  },
  {
    icon: Users2,
    title: "Custom CRMs",
    description:
      "Client management systems, lead tracking dashboards, sales pipelines, task management, and internal tools.",
  },
  {
    icon: FileText,
    title: "CMS Software",
    description:
      "Update pages, blogs, services, portfolios, and site content without needing a developer.",
  },
  {
    icon: Plug,
    title: "API Integration",
    description:
      "Connect websites and apps to Stripe, CRMs, booking systems, email platforms, databases, and business software.",
  },
  {
    icon: BrainCircuit,
    title: "AI Integration",
    description:
      "AI-powered chatbots, automation workflows, content tools, customer support assistants, and lead qualification.",
  },
];
